// extracted by mini-css-extract-plugin
export var container = "_3d-0";
export var error = "_3d-9";
export var label = "_3d-5";
export var light = "_3d-6";
export var md = "_3d-3";
export var sm = "_3d-2";
export var thin = "_3d-8";
export var thinBold = "_3d-7";
export var vertical = "_3d-4";
export var xs = "_3d-1";